import axios from '../../axios'

// 查询应用列表
export const getApplicationList = (data) => {
    return axios({
        url: '/api/admin/push/app',
        method: 'get',
        data
    })
}

// 查询应用通过ID
export const getApplicationById = (data) => {
    return axios({
        url: '/api/admin/push/app/get',
        method: 'get',
        data
    })
}

// 新增应用

export const saveApplication = (data) => {
    return axios({
        url: '/api/admin/push/app',
        method: 'post',
        data
    })
}

// 修改应用
export const updateApplication = (data) => {
    return axios({
        url: '/api/admin/push/app',
        method: 'put',
        data
    })
}

// 删除应用
export const deleteApplication = (data) => {
    return axios({
        url: '/api/admin/push/app',
        method: 'delete',
        data
    })
}

// 获取设备列表

export const getDeviceList = (data) => {
    return axios({
        url: '/api/admin/push/device',
        method: 'get',
        data
    })
}

// 获取设备详情

export const getDeviceById = (data) => {
    return axios({
        url: '/api/admin/push/device/get',
        method: 'get',
        data
    })
}

// 任务
// 获取任务列表

export const getTaskList = (data) => {
    return axios({
        url: '/api/admin/push/task',
        method: 'get',
        data
    })
}

// 获取任务详情

export const getTaskById = (data) => {
    return axios({
        url: '/api/admin/push/task/get',
        method: 'get',
        data
    })
}

// 新增任务
export const saveTask = (data) => {
    return axios({
        url: '/api/admin/push/task',
        method: 'post',
        data
    })
}

// 编辑任务
export const updateTask = (data) => {
    return axios({
        url: '/api/admin/push/task',
        method: 'put',
        data
    })
}

// 删除任务
export const deleteTask = (data) => {
    return axios({
        url: '/api/admin/push/task',
        method: 'delete',
        data
    })
}

// 构建任务
export const buildTask = (data) => {
    return axios({
        url: '/api/admin/push/task/build',
        method: 'post',
        data
    })
}

// 分发任务
export const distributeTask = (data) => {
    return axios({
        url: '/api/admin/push/status/push',
        method: 'post',
        data
    })
}

// 标签管理分页查询

export const getTagsList = (data) => {
    return axios({
        url: '/api/admin/push/device/tags',
        method: 'get',
        data
    })
}

// 状态分页查询
export const getStateList = (data) => {
    return axios({
        url: '/api/admin/push/status',
        method: 'get',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/trans/index.js